import { POST } from "."
import { ROUTE_LOGIN } from "../dist/api"

export const REQUEST_LOGIN = (formData) => {
    return POST(ROUTE_LOGIN, formData);
}